export const autoTableColumnLabels = {
    id: "ID",
    f_id: "ID pojazdu",
    f_supp_2_doc_invc_o_diff: "Dni",
    f_loc_lit: "Oddział",
    f_supp_2_loc: "Lokalizacja",
    f_vin: "VIN",
    f_prd_year: "Rok",
    f_veh_make: "Marka",
    f_veh_desc_1: "Model",
    f_veh_grp_1: "Rodzaj",
    f_svo_code_1: "Opis",
    f_svo_code_2: "Rocznik",
    f_svo_code_3: "Nadwozie",
    f_svo_code_4: "Wersja",
    f_svo_code_5: "Cena katalogowa",
    f_svo_code_6: "Silnik",
    f_svo_code_7: "Skrzynia biegów",
    f_svo_code_8: "Kolor",
    f_svo_code_9: "Tapicerka",
    f_supp_2_status_desc: "Status",
    f_sales_dat: "Data czynności",
    f_sales_cli_o_name: "Klient",
    f_sales_user_name: "Użytkownik",
    f_supp_2_doc_invc_num: "Numer f. zakupu",
    f_supp_2_doc_invc_d: "Data f. zakupu",
    f_supp_2_doc_invc_mnt: "Wart. f. zakupu",
    f_sales_xls_sales_mnt: "Min. cena sprzed.",
    f_vis_mark_7: "Stock2",
    f_sales_type: "Typ sprzedaży",
    f_sales_registr: "Numer rej.",
    f_sales_registr_dat: "Data rej.",
    f_lief_dat: "Data dost.",
    f_ord_num: "Numer zam.",
    f_ord_d: "Data zam.",
    f_veh_sec_1: "Sektor",
    // Tab Sprzedaż (dane z AutoTable)
    f_sales_agr_issue_dat: "Plan. data wydania",
    f_sales_invc_internal_d: "Data faktury",
    f_sales_invc_num: "Numer faktury",
    f_sales_book_mnt_D: "Wart. sprzedaży brutto",
    f_sales_book_mnt_C: "Wpłata",
} as const;

export type AutoTableColumnKey = keyof typeof autoTableColumnLabels;

